import { Component, OnInit } from '@angular/core';
import {TipoProducto} from '../../../models/tipo-producto.model';
import {CatalogosService} from '../../../services/catalogos.service';


@Component({
  selector: 'app-lista-productos-farmaceuticos',
  templateUrl: './lista-productos-farmaceuticos.component.html',
  styleUrls: ['./lista-productos-farmaceuticos.component.css']
})
export class ListaProductosFarmaceuticosComponent implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    },
    {
      label: 'Productos farmacéuticos',
      routerLink: '/farmaceuticos'
    }
  ];

  tipos: TipoProducto[];
  loading = false;

  constructor(private catalogosService: CatalogosService) { }

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposFarmaceuticos().subscribe((tipos) => {
      this.loading = false;
      this.tipos = tipos;
    });
  }

}
